module.exports = __webpack_public_path__ + "img/g_and_f_big.997c8d52.jpg";